import React, { useState } from 'react';

import DataSelect from '../common/DataSelect';
import { useGetRegionsQuery } from '../../redux/services/regionApi';

const SelectRegionInput = ({
  label = 'Region',
  ...props
}) => {
  // const [search, setSearch] = useState('');
  return (
    <DataSelect
      useGetQuery={useGetRegionsQuery}
      label={label}
      {...props}
    />
  );
};

export default SelectRegionInput;